module.exports = __webpack_public_path__ + "static/media/thumb-external.67a757fd.png";